import React from "react";

const dateIllustration = require("./images/date-illustration.svg");
const photographerLady = require("./images/photographer-lady.png");
const calendarIcon = require("./images/calendar.svg");
const downIcon = require("./images/down-icon.svg");

const CTASections = ({
  showMonthDatePopup,
  photographersPath
}: {
  showMonthDatePopup: () => void;
  photographersPath: string;
}) => {
  return (
    <div>
      <section className="photos-find-section">
        <div className="photos-find-div container-lock">
          <div className="panel-set photos-find-panels-text">
            <div className="panel-date panels flex-row justify-space-between open">
              <div className="wi">
                <img className="photos-date-img" src={dateIllustration} />
              </div>
              <div className="wr">
                <h2 className="highlighted">
                  Search for events by <span>Date</span>
                </h2>
                <p className="small">
                  Look for events that happened on a particular date and filter
                  the results
                </p>
                <div className="flex-row">
                  <button
                    className="primary-btn icon-btn"
                    style={{ lineHeight: "12px" }}
                    onClick={showMonthDatePopup}
                  >
                    <img src={calendarIcon} />
                    Select a Date <img className="down-ar" src={downIcon} />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="photos-more-section">
        <div className="container-lock flex-row justify-center">
          <div className="photos-more-div">
            <h2 className="highlighted">
              Ever thought of <span>sharing</span> or <span>selling</span> your
              own photos?
            </h2>
            <p className="big photos-more-p">
              Instant Photo Matching. Simplified event promotion.{" "}
              <b>No upfront costs.</b>
            </p>
            <button
              className="primary-btn big-btn"
              onClick={() => {
                window.location.href = photographersPath;
              }}
            >
              Learn More
            </button>
          </div>
          <div className="pm-im">
            <img srcSet={`${photographerLady}, ${photographerLady} 2x`} />
          </div>
        </div>
      </section>
    </div>
  );
};

export default CTASections;
